/**
 * 인증 헤더를 포함한 공통 fetch 래퍼
 * REACT_APP_API_KEY 환경변수가 설정된 경우 X-API-Key 헤더를 자동으로 추가합니다.
 */
const API_KEY = process.env.REACT_APP_API_KEY || '';

export function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers);
  if (API_KEY) {
    headers.set('X-API-Key', API_KEY);
  }
  return fetch(input, { ...init, headers });
}
